export default __webpack_public_path__ + "static/media/user-experience.c126b37f.svg";